export default {
    serverAddress: 'http://localhost:3001', // server address
    tipsPassword: 'secret123',
}